import PestPillarLayout from "./PestPillarLayout";

const PROBLEMS = [
  {
    title: "Échenillage",
    desc: "Retrait mécanique des nids à l'aide d'outils adaptés, avec combinaison et protections. Les nids sont ensuite détruits en toute sécurité. Méthode privilégiée de l'automne à la fin de l'hiver.",
  },
  {
    title: "Éco-pièges",
    desc: "Colliers posés autour du tronc qui interceptent les chenilles lors de leur descente, avant qu'elles n'atteignent le sol. Une solution sans produit chimique, à installer avant les processions.",
  },
  {
    title: "La bonne période",
    desc: "Les nids se forment en automne et les processions ont lieu le plus souvent entre janvier et avril, selon la météo. Une intervention anticipée limite les risques pour votre entourage.",
  },
];

const METHOD = [
  { title: "Diagnostic des arbres", desc: "Identification de l'espèce (pin ou chêne), repérage et comptage des nids, évaluation de l'accessibilité et des risques autour de la maison." },
  { title: "Méthode adaptée", desc: "Selon la saison et la hauteur des nids, nous proposons l'échenillage, la pose d'éco-pièges ou une combinaison des deux. Devis gratuit." },
  { title: "Intervention sécurisée", desc: "Retrait des nids avec équipement de protection, balisage de la zone si nécessaire et destruction des nids collectés." },
  { title: "Prévention", desc: "Conseils pour surveiller vos arbres, entretien des éco-pièges et recommandations pour les saisons suivantes." },
];

const FAQ = [
  {
    q: "Quelle est la meilleure période pour traiter les chenilles processionnaires ?",
    a: "L'échenillage se pratique de préférence de l'automne à la fin de l'hiver, lorsque les nids sont bien visibles et que les chenilles s'y trouvent encore. Les éco-pièges doivent être posés avant le début des processions, généralement en fin d'hiver. Le calendrier exact dépend de la météo et de l'espèce.",
  },
  {
    q: "Que faire si mon chien a touché une chenille ?",
    a: "Ne touchez pas la zone à mains nues, rincez abondamment la gueule à l'eau sans frotter et contactez immédiatement votre vétérinaire. Il s'agit d'une urgence.",
  },
  {
    q: "Puis-je retirer les nids moi-même ?",
    a: "C'est déconseillé : les poils urticants se dispersent facilement et peuvent provoquer de fortes réactions. Sans combinaison, gants et protection des yeux et des voies respiratoires, le risque est important. Faites appel à un professionnel équipé.",
  },
  {
    q: "Les éco-pièges suffisent-ils ?",
    a: "Les éco-pièges sont efficaces contre les chenilles processionnaires du pin, qui descendent le long du tronc. Ils sont souvent associés à l'échenillage lorsque les nids sont nombreux. Nous vous conseillons la combinaison la plus adaptée après avoir examiné vos arbres.",
  },
];

const CITIES = ["Guéret", "La Souterraine", "Aubusson", "Bourganeuf", "Boussac", "La Celle-Dunoise"];

const RELATED = [
  { title: "Chenilles processionnaires : quand et comment s'en débarrasser en Creuse", slug: "chenilles-processionnaires-quand-comment-s-en-debarrasser-creuse" },
  { title: "Chenilles processionnaires : danger et traitement en Creuse", slug: "chenilles-processionnaires-danger-traitement" },
];

export default function ChenillesProcessionnairesCreuse() {
  return (
    <PestPillarLayout
      slug="chenilles-processionnaires-creuse"
      seoTitle="Chenilles processionnaires Creuse (23) | K'REUSE"
      seoDescription="Lutte contre les chenilles processionnaires en Creuse (23) : échenillage, éco-pièges et conseils selon la période. Intervention sécurisée, devis gratuit."
      breadcrumbLabel="Chenilles processionnaires Creuse"
      heroBadge="Échenillage · Éco-pièges · Certibiocide"
      heroTitleHtml={`Chenilles processionnaires en <span class="font-medium text-[#1B5E20]">Creuse (23)</span>`}
      heroSubtitle="Pins, chênes, cèdres : nous retirons les nids de chenilles processionnaires et installons des éco-pièges, en choisissant la bonne méthode selon la saison."
      hero_h2="Protéger votre famille et vos animaux"
      introParagraphs={[
        "Les chenilles processionnaires du pin et du chêne sont bien présentes en Creuse. Elles se reconnaissent à leurs nids soyeux blancs accrochés aux branches et à leurs déplacements en file indienne au sol, au moment où elles quittent l'arbre pour s'enfouir.",
        "Leur danger vient de leurs poils urticants, très légers, qui se dispersent dans l'air. Ils peuvent provoquer des démangeaisons, des irritations des yeux ou des réactions respiratoires chez l'humain. Chez le chien et le chat, un contact avec la langue peut entraîner des lésions graves : il faut alors consulter un vétérinaire sans attendre.",
        "K'REUSE EXTÉRIEUR intervient avec un équipement de protection adapté pour retirer et détruire les nids, et installe des éco-pièges autour des troncs. Le choix de la méthode dépend de la période de l'année : c'est pourquoi chaque intervention commence par un diagnostic de vos arbres, suivi d'un devis gratuit et détaillé.",
      ]}
      problems={PROBLEMS}
      method={METHOD}
      cities={CITIES}
      faq={FAQ}
      relatedArticles={RELATED}
      ctaTitle="Des nids dans vos pins ou vos chênes ? Contactez-nous."
      whatsappText="Bonjour, je souhaite un devis pour des chenilles processionnaires en Creuse."
      withQuoteForm
      quoteServiceIndex={8}
      quoteIntro="Des nids dans vos arbres ? Précisez l'essence (pin, chêne…) et le nombre de nids visibles : nous vous recontactons pour un diagnostic et un devis gratuit."
    />
  );
}
